import { request } from '@/utils/request'
import { GearVRController } from 'babylonjs'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 用户区域分配数据查询
    GetUserarea({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/User/GetUserGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 公司下拉框接口
    getcompanylist({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Organize/GetGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getallcompanylist({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Organize/GetTreeGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default StationManageService
